import React, { Component, Fragment } from 'react';
import cookie from 'react-cookies';
class TemplateDetail extends Component {
  getTemplateIcon = (snippetType) => {
    switch (snippetType) {
      case 'MODAL':
        return 'webconnect webconnect-files-alt';
      case 'SNIPPET':
        return 'webconnect webconnect-layout-text-window-reverse';
      case 'SUB_PAGE':
        return 'webconnect webconnect-file-earmark-richtext';
      case 'PDF_TEMPLATE':
        return 'webconnect webconnect-layout-text-window-reverse';
      default:
        return 'webconnect webconnect-breadcrumb';
    }
  };

  render() {
    const { name, uuid, projectId, uri, template, redirectUrl, snippetType, version } = this.props;
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    return (
      <Fragment>
        <a
          href={`${redirectUrl}editor/${version}/v/${projectId}/${uri}/${uuid}?token=${token}`}
          className={`list-group-item list-group-item-action align-items-center `}
          style={{ cursor: 'pointer', float: 'left' }}
        >
          <i className={this.getTemplateIcon(snippetType)}></i>
          &nbsp;{name}
        </a>
      </Fragment>
    );
  }
}

export default TemplateDetail;
